module.exports = __webpack_public_path__ + "static/media/Siemens_Sans_Bold_Italic.b697ac9e.ttf";